import React from 'react';
import { UiMessages } from '../uiMessages';

export function UploadProcessingOverlay() {
  return (
    <div className="upload-processing-overlay" aria-live="polite" aria-modal="true">
      <div className="upload-processing-backdrop" />
      <div className="upload-processing-dialog">
        <span className="upload-processing-spinner" aria-hidden="true" />
        <div className="upload-processing-title">{UiMessages.processingTitle}</div>
        <div className="upload-processing-text">{UiMessages.processingText}</div>
      </div>
    </div>
  );
}
